<template>
  <v-main>
    <v-container fluid class="py-6">
      <!-- Dashboard Header -->
      <v-row class="mb-6">
        <v-col cols="12">
          <div class="text-h4 font-weight-bold text-center mb-2">
            Dashboard
          </div>
          <div class="text-subtitle-1 text-center text--secondary">
            Navigate to key sections of your business management system
          </div>
        </v-col>
      </v-row>

      <!-- Quick Stats Cards -->
      <v-row class="mb-8">
        <v-col cols="12" sm="6" md="3" v-for="stat in quickStats" :key="stat.title">
          <v-card class="stat-card" elevation="2" @click="navigateTo(stat.route)">
            <v-card-text class="text-center">
              <v-icon :color="stat.color" size="48" class="mb-3">
                {{ stat.icon }}
              </v-icon>
              <div class="text-h5 font-weight-bold">{{ stat.count }}</div>
              <div class="text-body-2 text--secondary">{{ stat.title }}</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Main Navigation Cards -->
      <v-row>
        <v-col 
          cols="12" 
          sm="6" 
          md="4" 
          lg="3" 
          v-for="section in navigationSections" 
          :key="section.title"
          class="mb-4"
        >
          <v-card 
            class="navigation-card"
            elevation="2"
            hover
            @click="navigateTo(section.route)"
          >
            <v-card-text class="text-center py-6">
              <v-icon :color="section.color" size="56" class="mb-3">
                {{ section.icon }}
              </v-icon>
              <div class="text-h6 font-weight-bold mb-2">{{ section.title }}</div>
              <div class="text-body-2 text--secondary mb-4">{{ section.description }}</div>
              
              <!-- Sub-items -->
              <v-divider class="mb-3"></v-divider>
              <div class="sub-items">
                <v-chip
                  v-for="item in section.items"
                  :key="item.name"
                  small
                  class="ma-1"
                  @click.stop="navigateTo(item.route)"
                >
                  {{ item.name }}
                </v-chip>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Recent Activity Section -->
      <v-row class="mt-8">
        <v-col cols="12">
          <v-card elevation="2">
            <v-card-title>
              <v-icon class="mr-2">mdi-history</v-icon>
              Recent Activity
            </v-card-title>
            <v-card-text>
              <div class="text-center py-4 text--secondary">
                Recent activity will appear here once you start using the system
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
export default {
  name: "HomePage",
  data() {
    return {
      isLoading: false,
      roleId: "",
      counts: {},
      attendace_count: [],
      startDate: "",
      endDate: "",
      userAttendances: [],
      current_date: "",
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      search_keyword: "",
      designations: [
        {
          id: 0,
          text: "Select Designation",
          value: "",
        },
      ],
      designationId: "",
      selectedDateRange: "daily",
      quickStats: [
        { title: "Total Users", count: "1,234", icon: "mdi-account-group", color: "primary", route: "/users" },
        { title: "Active Stores", count: "56", icon: "mdi-store", color: "success", route: "/stores" },
        { title: "Products", count: "789", icon: "mdi-package-variant", color: "orange", route: "/products" },
        { title: "Sales Today", count: "₹45,678", icon: "mdi-chart-line", color: "teal", route: "/sales" }
      ],
      navigationSections: [
        {
          title: "User Management",
          description: "Manage users, KYC, and user data",
          icon: "mdi-account",
          color: "primary",
          route: "/users",
          items: [
            { name: "Users", route: "/users" },
            { name: "KYC Approved", route: "/kyc-approved-users" },
            { name: "Old User Data", route: "/old-user-datas" }
          ]
        },
        {
          title: "Inventory & Products",
          description: "Manage products, raw materials, and production",
          icon: "mdi-package-variant",
          color: "orange",
          route: "/products",
          items: [
            { name: "Products", route: "/products" },
            { name: "Raw Materials", route: "/raw-materials" },
            { name: "Production", route: "/productions" }
          ]
        },
        {
          title: "Store Management",
          description: "Manage stores, orders, and inventory",
          icon: "mdi-store-alert-outline",
          color: "success",
          route: "/stores",
          items: [
            { name: "Stores", route: "/stores" },
            { name: "Orders", route: "/orders" },
            { name: "Stock Management", route: "/stores" }
          ]
        },
        {
          title: "Sales & Analytics",
          description: "Track sales performance and reports",
          icon: "mdi-chart-line",
          color: "teal",
          route: "/sales",
          items: [
            { name: "Sales", route: "/sales" },
            { name: "Sale Reports", route: "/sale-reports" },
            { name: "Analytics", route: "/user-timestamps" }
          ]
        },
        {
          title: "Gift & Rewards",
          description: "Manage gifts, rewards, and redemptions",
          icon: "mdi-gift-outline",
          color: "pink",
          route: "/gifts",
          items: [
            { name: "Gifts", route: "/gifts" },
            { name: "Gift Categories", route: "/gift-categories" },
            { name: "Redemptions", route: "/gift-redemptions" }
          ]
        },
        {
          title: "Point Management",
          description: "Handle point mappings and user wallets",
          icon: "mdi-hand-coin-outline",
          color: "amber",
          route: "/point-mappings",
          items: [
            { name: "Point Mappings", route: "/point-mappings" },
            { name: "User Wallets", route: "/user-wallet-logs" },
            { name: "Point Logs", route: "/point-mapping-logs" }
          ]
        },
        {
          title: "Customer Inquiries",
          description: "Manage customer inquiries and requests",
          icon: "mdi-form-select",
          color: "indigo",
          route: "/inquiry-requests",
          items: [
            { name: "Inquiries", route: "/inquiry-requests" },
            { name: "Contact Requests", route: "/contact-requests" },
            { name: "Complaints", route: "/raise-complaints" }
          ]
        },
        {
          title: "Financial Management",
          description: "Handle bank details and financial records",
          icon: "mdi-bank",
          color: "deep-purple",
          route: "/bank_details",
          items: [
            { name: "Bank Details", route: "/bank_details" },
            { name: "Payment Receipts", route: "/user-wallet-logs" },
            { name: "Financial Reports", route: "/sale-reports" }
          ]
        },
        {
          title: "Communications",
          description: "Manage notifications and chat system",
          icon: "mdi-bell",
          color: "cyan",
          route: "/notifications",
          items: [
            { name: "Notifications", route: "/notifications" },
            { name: "Chat", route: "/chats" },
            { name: "Festival Banners", route: "/festival-banners" }
          ]
        },
        {
          title: "System Settings",
          description: "Configure system settings and permissions",
          icon: "mdi-cogs",
          color: "grey",
          route: "/modules",
          items: [
            { name: "Modules", route: "/modules" },
            { name: "Permissions", route: "/permissions" },
            { name: "Positions", route: "/positions" }
          ]
        },
        {
          title: "Reports & Analytics",
          description: "View comprehensive reports and analytics",
          icon: "mdi-file-chart",
          color: "red",
          route: "/sale-reports",
          items: [
            { name: "Sale Reports", route: "/sale-reports" },
            { name: "User Activity", route: "/user-timestamps" },
            { name: "Cancellation Logs", route: "/cancellation-logs" }
          ]
        },
        {
          title: "Data Management",
          description: "Manage data imports, exports, and cleanup",
          icon: "mdi-database",
          color: "brown",
          route: "/values",
          items: [
            { name: "Values", route: "/values" },
            { name: "Value Lists", route: "/value-lists" },
            { name: "Old User Points", route: "/old-user-used-points" }
          ]
        }
      ]
    };
  },
  methods: {
    navigateTo(route) {
      if (route) {
        this.$router.push(route);
      }
    }
  }
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Afacad:wght@400;500&display=swap");

/* Dashboard Styles */
.stat-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 12px !important;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
}

.navigation-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 16px !important;
  height: 100%;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.navigation-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 35px rgba(0,0,0,0.15) !important;
}

.sub-items {
  min-height: 40px;
}

.sub-items .v-chip {
  transition: all 0.2s ease;
  cursor: pointer;
}

.sub-items .v-chip:hover {
  transform: scale(1.05);
}

/* Quick Stats specific styling */
.stat-card .v-card__text {
  padding: 24px 16px !important;
}

/* Navigation cards styling */
.navigation-card .v-card__text {
  padding: 24px !important;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .navigation-card .v-card__text {
    padding: 16px !important;
  }
  
  .stat-card .v-card__text {
    padding: 16px 12px !important;
  }
}

/* Header styling */
.text-h4 {
  color: #2c3e50;
  font-family: "Afacad", sans-serif !important;
}

.text-subtitle-1 {
  color: #7f8c8d;
}

/* Card title styling */
.text-h6 {
  color: #34495e;
  font-family: "Afacad", sans-serif !important;
}

/* Recent Activity card */
.v-card .v-card__title {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  color: white !important;
  padding: 16px 24px;
}

.v-card .v-card__title .v-icon {
  color: white !important;
}

/* Legacy chart styles - keeping for compatibility */
.chart_data {
  display: flex;
}

#chart,
#chart1 {
  background: white;
}

.card-button2 {
  padding: 7px 15px !important;
  background: #3354f4;
  color: white;
  border-radius: 10px;
  font-size: 14px;
}

.page-content {
  width: 100%;
}

.search-field {
  border: 1px solid #dfe2e5;
  border-radius: 10px;
}

.search-field2 {
  border: 1px solid #dfe2e5;
  border-radius: 10px;
}

.text-left {
  color: #c1c1c5 !important;
}

.chart-radio {
  position: absolute;
  top: 20px;
  right: 32px;
}

.chart-radio input {
  margin-left: 10px;
  margin-right: 3px;
}

.chart-radio label {
  color: #6c718e !important;
  font-family: "Afacad", sans-serif;
}
</style>
